import clsx from 'clsx';
import React from 'react';
import AccountIcon from '../../assets/icons/account-icon.svg?react';
import Input from '../Input';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import DatePicker from '../DatePicker';
import moment from 'moment';

interface EditPersonalDetailsModalProps {
  otherClasses?: string;
  formHandler: any;
  handleClose: () => void;
}

const EditPersonalDetailsModal: React.FC<EditPersonalDetailsModalProps> = ({
  otherClasses,
  formHandler,
  handleClose,
}) => {
  const editPersonalDetailsModalClasses = clsx(otherClasses);
  const sm = useButtonSizeSmall();
  return (
    <div
      className={editPersonalDetailsModalClasses}
      data-testid="edit-personal-details-modal"
    >
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <AccountIcon className="svg-path-current-color-stroke [&>path]:!stroke-brand-byzantine/100 !h-12 !w-12 md:!h-85 md:!w-85" />
        <h4 className="text-brand-byzantine">Edit Personal Details</h4>
        <p className="text-brand-byzantine font-inter-variable text-lg leading-5 font-normal">
          Update your personal details by filling in the required fields and
          clicking 'Update Details' to save changes.
        </p>
      </div>
      <form action="#" onSubmit={formHandler?.handleSubmit}>
        <Input
          onBlur={formHandler?.handleBlur}
          label="Name*"
          errorMessage={
            formHandler?.touched.fullName && formHandler?.errors.fullName
              ? formHandler?.errors.fullName
              : ''
          }
          disabled={formHandler?.isSubmitting}
          value={formHandler?.values.fullName}
          type="text"
          placeholder="Enter your name"
          onChange={formHandler?.handleChange}
          name="fullName"
          otherClasses={{ container: 'w-full mb-6' }}
        />
        <Input
          onBlur={formHandler?.handleBlur}
          label="Email*"
          errorMessage={
            formHandler?.touched.email && formHandler?.errors.email
              ? formHandler?.errors.email
              : ''
          }
          disabled={formHandler?.isSubmitting}
          value={formHandler?.values.email}
          type="email"
          placeholder="someone@gmail.com"
          onChange={formHandler?.handleChange}
          name="email"
          otherClasses={{ container: 'w-full mb-6' }}
          aria-required={true}
          aria-invalid={
            formHandler?.touched.email && !!formHandler?.errors.email
          }
          aria-describedby={
            formHandler?.touched.email && formHandler?.errors.email
              ? 'email-error'
              : undefined
          }
        />
        <Input
          onBlur={formHandler.handleBlur}
          label={
            <>
              Contact Number <em className="text-sm font-normal">(Optional)</em>
            </>
          }
          errorMessage={
            formHandler?.touched.contact && formHandler?.errors.contact
              ? formHandler?.errors.contact
              : ''
          }
          disabled={formHandler.isSubmitting}
          value={formHandler.values.contact}
          type="tel"
          placeholder="Enter contact number"
          onChange={formHandler.handleChange}
          name="contact"
          otherClasses={{ container: 'w-full mb-6' }}
        />
        <DatePicker
          otherClasses={{
            container: 'w-full',
            dropdownMainContainer: 'bottom-18 top-auto',
          }}
          label={
            <>
              Date of Birth <em className="text-sm font-normal">(Optional)</em>
            </>
          }
          name="date"
          startMonth={moment([1950, 0]).toDate()}
          endMonth={moment().toDate()}
          // endMonth={moment().subtract(18, 'years').toDate()}
          value={String(formHandler?.values?.dob)}
          placeholder="Select date of birth"
          // onBlur={formHandler.handleBlur}
          onBlur={() => {
            if (formHandler?.values?.dob) {
              formHandler?.setFieldTouched('dob', true);
            }
          }}
          disabled={formHandler.isSubmitting}
          onChange={(e) => {
            if (e) {
              formHandler?.setFieldValue('dob', e, true);
            } else {
              formHandler?.setFieldValue('dob', '', true);
            }
          }}
          errorMessage={
            formHandler?.touched.dob && formHandler?.errors.dob
              ? formHandler?.errors.dob
              : ''
          }
        />
        <div className="mt-8 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
          <Button
            variant="secondary"
            type="button"
            size={sm}
            onClick={() => handleClose()}
            otherClasses="text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            size={sm}
            disable={
              (formHandler?.initialValues?.fullName ===
                formHandler?.values?.fullName &&
                formHandler?.initialValues?.email ===
                  formHandler?.values?.email &&
                formHandler?.initialValues?.contact ===
                  formHandler?.values?.contact &&
                formHandler?.initialValues?.dob === formHandler?.values?.dob) ||
              formHandler?.isSubmitting
            }
          >
            Update Details
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditPersonalDetailsModal;
